var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState, useMemo } from 'react';
import theme from '../theme/theme';
var breakpoints = theme.breakpoints;
export var queries = breakpoints.map(function (breakpoint) { return "(min-width: " + breakpoint + ")"; });
export var useMatchesViewport = function (defaultMatchesTablet, defaultMatchesDesktop, defaultMatchesLargeDesktop) {
    if (defaultMatchesTablet === void 0) { defaultMatchesTablet = true; }
    if (defaultMatchesDesktop === void 0) { defaultMatchesDesktop = true; }
    if (defaultMatchesLargeDesktop === void 0) { defaultMatchesLargeDesktop = true; }
    var _a = __read(useState(defaultMatchesTablet), 2), matchesTablet = _a[0], setMatchesTablet = _a[1];
    var _b = __read(useState(defaultMatchesDesktop), 2), matchesDesktop = _b[0], setMatchesDesktop = _b[1];
    var _c = __read(useState(defaultMatchesLargeDesktop), 2), matchesLargeDesktop = _c[0], setMatchesLargeDesktop = _c[1];
    var mediaQueryList = useMemo(function () {
        return typeof window !== 'undefined'
            ? queries.map(function (query) { return window.matchMedia(query); })
            : [];
    }, [queries]);
    useEffect(function () {
        var handlers = [
            setMatchesTablet,
            setMatchesDesktop,
            setMatchesLargeDesktop,
        ];
        mediaQueryList.forEach(function (_a, index) {
            var matches = _a.matches;
            return handlers[index](matches);
        });
    }, [mediaQueryList]);
    useEffect(function () {
        var handlers = [
            setMatchesTablet,
            setMatchesDesktop,
            setMatchesLargeDesktop,
        ];
        var listenerHandlers = handlers.map(function (handler) { return function (_a) {
            var matches = _a.matches;
            return handler(matches);
        }; });
        mediaQueryList.forEach(function (mediaQuery, index) {
            mediaQuery.addListener(listenerHandlers[index]);
        });
        return function () {
            mediaQueryList.forEach(function (mediaQuery, index) {
                mediaQuery.removeListener(listenerHandlers[index]);
            });
        };
    }, [mediaQueryList]);
    return [matchesTablet, matchesDesktop, matchesLargeDesktop];
};
